/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { BottomAppliance, BottomCabinet, BottomCabinetAppliance, BottomPart, BottomWallAppliance, BottomWallItem, BurnerBase, BurnerBaseW18, BurnerBaseW24, CornerFiller, CountertopAppliance, CountertopWallItem, Drawer33Door66, EndPanel, EvoAffinity25G, EvoAffinity30G, EvoBaseW36, Filler, FullDoorBase, GrillBase, KamadoGrillBase, LynxAsadoGriddgle, LynxBurner, LynxKamadoGrill, LynxNapoliPizzaOven, LynxProfessionalBurner, LynxProfessionalCocktailStation, LynxProfessionalDoubleBurner, LynxProfessionalDoubleTapTowerKit, LynxProfessionalGrill, LynxProfessionalGrillW30, LynxProfessionalGrillW36, LynxProfessionalGrillW42, LynxProfessionalGrillW54, LynxProfessionalOutdoorBeverageDispenserW24, LynxProfessionalOutdoorIceMachineDrainPump, LynxProfessionalOutdoorIceMachineW15, LynxProfessionalOutdoorRefrigeratorW24, LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24, LynxProfessionalPowerBurner, LynxProfessionalRefrigeratorFreezerComboW24, LynxProfessionalRefrigeratorW15, LynxProfessionalSingleBurner, LynxProfessionalSingleTapTowerKit, LynxProfessionalTwoDrawerRefrigeratorW24, LynxProfessionalWineCellarW15, LynxSedonaBurner, LynxSedonaDoubleBurner, LynxSedonaGrill, LynxSedonaGrillW30, LynxSedonaGrillW36, LynxSedonaGrillW42, LynxSedonaHood, LynxSedonaHoodW36, LynxSedonaHoodW42, LynxSedonaHoodW48, LynxSedonaSingleBurner, LynxSinkBase, LynxSinkW18, LynxSinkW24, LynxSinkW30, LynxWarmingDrawer, RearPanel, Room, SinkBase, ThreeDrawerBase, TopAppliance, TopWallItem, TrashPulloutBase, Wall } from './model/index.js';
export const constants = {
    BurnerBase: {
        $depth: 27.25 * 25.4
    },
    BurnerBaseW18: {
        $netWidth: 18 * 25.4,
        $countertopDepthInner: 6 * 25.4
    },
    BurnerBaseW24: {
        $netWidth: 24 * 25.4,
        $countertopDepthInner: 1 * 25.4
    },
    BottomWallItem: {
        $doorModelWidthScaleZero: 17.9 * 25.5,
        $doorModelWidthScaleOne: 23.9 * 25.4,
        $doorModelHeightScaleZero: 10.5 * 25.4,
        $doorModelHeightScaleOne: 21.1 * 25.4,
        $handleModelScaleZero: 11.3 * 25.4,
        $handleModelScaleOne: 15.7 * 25.4,
        $toeKickInset: 2.5 * 25.4,
        $countertopOffsetZ: 1.75 * 25.4,
        $countertopSideOverhang: 0.5 * 25.4,
        $endPanelWidth: 1 * 25.4,
        $endPanelDepthScaleZero: 24 * 25.4,
        $endPanelDepthScaleOne: 30.617 * 25.4,
        $endPanelHeightScaleZero: 30.2 * 25.4,
        $endPanelHeightScaleOne: 36.617 * 25.4,
        $handleDepthOffset: 0.5 * 25.4,
        $handleSideOffset: 1.5 * 25.4,
        $toeKickDepthScaleZero: 1.25 * 25.4,
        $toeKickDepthScaleOne: 33 * 25.4,
        $frontPanelBottomOverhang: 1.125 * 25.4
    },
    BottomWallItemWithBackPanel: {
        $backPanelOverhang: 0.5 * 25.4,
        $backPanelWidthScaleZero: 12 * 25.4,
        $backPanelWidthScaleOne: 18 * 25.4
    },
    BottomCabinet: {
        $height: 35.25 * 25.4
    },
    BottomCabinetWithAppliance: {
        $countertopDepthInnerScaleZero: 0 * 25.4,
        $countertopDepthInnerScaleOne: 6 * 25.4,
        $countertopSideWidthScaleZero: 0 * 25.4,
        $countertopSideWidthScaleOne: 6 * 25.4
    },
    BottomWallItemWithDefaultCountertop: {
        $countertopDepthScaleZero: 25.75 * 25.4,
        $countertopDepthScaleOne: 34.714 * 25.4
    },
    CornerFiller: {
        $name: 'Corner Filler',
        $sku: 'P-CFIL-3.5x3.5',
        $description: null,
        $countertopOffsetZ: 1.75 * 25.4,
        $heightScaleZero: 30.617 * 25.4,
        $heightScaleOne: 36.617 * 25.4,
        $countertopScaleZero: 18 * 25.4,
        $countertopScaleOne: 42 * 25.4,
        $countertopDepthScaleZero: 25.75 * 25.4,
        $countertopDepthScaleOne: 34.714 * 25.4,
        $wallCornerThickness: 150,
        $backPanelWidthScaleZero: 12 * 25.4,
        $backPanelWidthScaleOne: 18 * 25.4,
        $toeKickWidthScaleZero: 17.6 * 25.4,
        $toeKickWidthScaleOne: 42 * 25.4,
        $toeKickDepthScaleZero: 1.25 * 25.4,
        $toeKickDepthScaleOne: 33 * 25.4,
        $toeKickInset: 2.5 * 25.4,
        $frontPanelBottomOverhang: 1.125 * 25.4
    },
    SinkBase: {
        $depth: 27.25 * 25.4,
        $countertopDepthInner: 1 * 25.4
    },
    LynxSinkBase: {
        $depth: 27.25 * 25.4,
        $countertopDepthInner: 1 * 25.4
    },
    Drawer33Door66: {
        $depth: 27.25 * 25.4
    },
    EndPanel: {
        $height: 35 * 25.4,
        $netWidth: 1 * 25.4
    },
    Filler: {
        $height: 35 * 25.4,
        $depth: 27.25 * 25.4
    },
    GrillBase: {
        $depth: 27.25 * 25.4,
        $countertopDepthInner: 0
    },
    EvoBaseW36: {
        $netWidth: 36 * 25.4,
        $depth: 27.25 * 25.4,
        $countertopDepthInner: 0
    },
    FullDoorBase: {
        $depth: 27.25 * 25.4,
        $countertopDepthInner: 6 * 25.4
    },
    KamadoGrillBase: {
        $netWidth: 30 * 25.4,
        $depth: 27.25 * 25.4,
        $countertopDepthInner: -3 * 25.4
    },
    LynxSedonaHood: {
        $depth: 32 * 25.4,
        $height: 25 * 25.4
    },
    LynxSedonaHoodW36: {
        $netWidth: 36 * 25.4
    },
    LynxSedonaHoodW42: {
        $netWidth: 42 * 25.4
    },
    LynxSedonaHoodW48: {
        $netWidth: 48 * 25.4
    },
    Room: {
        $ignoredCabinetSpace: 0.25 * 25.4,
        $cornerFillerExtraSpace: (31.75 - 27.25) * 25.4,
        $cornerCabinetWidth: 31.75 * 25.4,
        $minCabinetHeight: 35 * 25.4,
        $minCabinetDepth: 27.25 * 25.4,
        $inchToMm: 25.4,
        $toeKickHeight: 4.75 * 25.4,
        $minGapForOpenCabinet: 4 * 25.4,
        $doorThickness: 1.25 * 25.4,
        $cabinetSideGap: 0.79375,
        $backPanelDepth: 1 * 25.4,
        $smallHandleLength: 11.3 * 25.4,
        $largeHandleLength: 15.7 * 25.4
    },
    ThreeDrawerBase: {
        $depth: 27.25 * 25.4
    },
    TrashPulloutBase: {
        $depth: 27.25 * 25.4
    },
    Wall: {
        $fullHeight: 2500,
        $hiddenHeight: 10,
        $countertopThickness: 1.5 * 25.4,
        $wallThickness: 150
    },
    LynxProfessionalOutdoorBeverageDispenserW24: {
        $netWidth: 23.9204 * 25.4,
        $depth: 26.9304 * 25.4
    },
    LynxProfessionalRefrigeratorFreezerComboW24: {
        $netWidth: 23.9204 * 25.4,
        $depth: 26.9304 * 25.4
    },
    LynxProfessionalOutdoorRefrigeratorW24: {
        $netWidth: 23.9204 * 25.4,
        $depth: 26.9304 * 25.4
    },
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24: {
        $netWidth: 23.9204 * 25.4,
        $depth: 26.9304 * 25.4
    },
    LynxProfessionalRefrigeratorW15: {
        $netWidth: 15.0309 * 25.4,
        $depth: 27.25 * 25.4
    },
    LynxProfessionalWineCellarW15: {
        $netWidth: 15.0309 * 25.4,
        $depth: 27.25 * 25.4
    },
    LynxProfessionalTwoDrawerRefrigeratorW24: {
        $netWidth: 23.9155 * 25.4,
        $depth: 26.9196 * 25.4
    },
    LynxProfessionalOutdoorIceMachineW15: {
        $netWidth: 15.0309 * 25.4,
        $depth: 27.0902 * 25.4
    },
    LynxNapoliPizzaOven: {
        $netWidth: 30 * 25.4,
        $depth: 28.5 * 25.4
    }
};
const AdjustableDoorCabinetExpressions = [
    '$doorHeight',
    '$doorLeftFilter',
    '$doorLeftOffsetX',
    '$doorOffsetY',
    '$doorRightFilter',
    '$doorRightOffsetX',
    '$doorWidth',
    '$handleLeftOffsetX',
    '$handleLength',
    '$handleOffsetY',
    '$handleOffsetZ',
    '$handleRightOffsetX',
    '$isOneWingDoorCabinet',
    '$handingOptions',
    '$doorTopFilter',
    '$handleLeftFilter',
    '$handleRightFilter',
    '$handleTopFilter',
    '$doorOffsetZ',
    '$doorModelWidthScaleZero',
    '$doorModelWidthScaleOne',
    '$doorModelHeightScaleZero',
    '$doorModelHeightScaleOne',
    '$handleModelScaleZero',
    '$handleModelScaleOne',
    '$handleTopOffsetX',
    '$handleTopOffsetY'
];
const ApplianceExpressions = [
    '$fuelTypes'
];
const BottomWallApplianceExpressions = [
    '$thumbnailUrl',
    '$name',
    '$sku',
    '$description'
];
const BottomCabinetExpressions = [
    '$thumbnailUrl',
    '$height'
];
const BurnerBaseExpressions = [
    '$countertopSideOuterWidth',
    '$depth'
];
const FullDoorBaseExpressions = [
    '$countertopSideOuterWidth',
    '$width',
    '$depth',
    '$countertopDepthInner'
];
const KamadoGrillBaseExpressions = [
    '$countertopSideOuterWidth',
    '$netWidth',
    '$depth',
    '$countertopDepthInner'
];
const SinkBaseExpressions = [
    '$countertopSideOuterWidth',
    '$width',
    '$depth',
    '$countertopDepthInner'
];
const LynxSinkBaseExpressions = [
    '$countertopSideOuterWidth',
    '$width',
    '$depth',
    '$countertopDepthInner'
];
const WallItemExpressions = [
    '$height',
    '$width',
    '$netWidth',
    '$depth',
    '$isStackItemSnapped',
    '$isStackItemSnappedLeft',
    '$isStackItemSnappedRight',
    '$isStackItemAtTheLeftEdge',
    '$isStackItemAtTheRightEdge',
    '$isStackItemAtTheEdge',
    '$freeSpaceLeft',
    '$freeSpaceRight',
    '$selectHotspotOffsetX',
    '$selectHotspotOffsetY',
    '$selectHotspotOffsetZ',
    '$draggableFilter',
    '$surfaces'
];
const BottomWallItemExpressions = [
    '$offsetZ',
    '$countertopDepth',
    '$countertopExtraWidth',
    '$netHeight',
    '$leftSideOpen',
    '$rightSideOpen',
    '$frontPanelHeight',
    '$backPanelFilter',
    '$hasWorkSurface',
    '$dimensionIndicatorWidthActive',
    '$dimensionIndicatorWidthEndX',
    '$dimensionIndicatorLabelWallFontSize',
    '$wall',
    '$doorModelWidthScaleZero',
    '$doorModelWidthScaleOne',
    '$doorModelHeightScaleZero',
    '$doorModelHeightScaleOne',
    '$handleModelScaleZero',
    '$handleModelScaleOne',
    '$toeKickInset',
    '$countertopOffsetZ',
    '$countertopSideOverhang',
    '$endPanelWidth',
    '$endPanelDepthScaleZero',
    '$endPanelDepthScaleOne',
    '$endPanelHeightScaleZero',
    '$endPanelHeightScaleOne',
    '$handleDepthOffset',
    '$handleSideOffset',
    '$toeKickDepthScaleZero',
    '$toeKickDepthScaleOne',
    '$frontPanelBottomOverhang'
];
const TopWallItemExpressions = [
    '$offsetY',
    '$name',
    '$sku',
    '$description',
    '$thumbnailUrl',
    '$wall'
];
const CountertopWallItemExpressions = [
    '$offsetX',
    '$offsetY',
    '$name',
    '$sku',
    '$description',
    '$thumbnailUrl',
    '$offsetZ',
    '$wall'
];
const RearPanelExpressions = [
    '$width'
];
const RoomExpressions = [
    '$wallA',
    '$wallB',
    '$wallC',
    '$depth',
    '$width',
    '$maxSideLength',
    '$summary',
    '$appliancePrice',
    '$cabinetsAndPartsPrice',
    '$totalPrice',
    '$cameraNear',
    '$cameraFar',
    '$cameraMinDistance',
    '$cameraMaxDistance',
    '$boundingBoxMinX',
    '$boundingBoxMinY',
    '$boundingBoxMinZ',
    '$boundingBoxMaxX',
    '$boundingBoxMaxY',
    '$boundingBoxMaxZ',
    '$drawer33Door66Recipes',
    '$fullDoorBaseRecipes',
    '$lynxProfessionalBurnerRecipes',
    '$lynxProfessionalRecipes',
    '$lynxSedonaGrillRecipes',
    '$lynxSedonaHoodRecipes',
    '$lynxSinkRecipes',
    '$lynxSedonaBurnerRecipes',
    '$lynxEvoRecipes',
    '$sinkBaseCabinetRecipes',
    '$otherCookingItemRecipes',
    '$threeDrawerBaseRecipes',
    '$trashPulloutBaseRecipes',
    '$fillerRecipes',
    '$refrigerationRecipes',
    '$endPanelRecipes',
    '$frontPanelColor',
    '$frontPanelMetalness',
    '$frontPanelReflectivity',
    '$frontPanelClearcoat',
    '$frontPanelClearcoatRoughness',
    '$frontPanelRoughness',
    '$frontPanelRoughnessMapUrl',
    '$frontPanelNormalMapUrl',
    '$frontPanelNormalScale',
    '$frontPanelRepeatX',
    '$frontPanelRepeatY',
    '$cabinetColor',
    '$cabinetMetalness',
    '$cabinetReflectivity',
    '$cabinetClearcoat',
    '$cabinetClearcoatRoughness',
    '$cabinetRoughness',
    '$cabinetRoughnessMapUrl',
    '$cabinetNormalMapUrl',
    '$cabinetNormalScale',
    '$cabinetRepeatX',
    '$cabinetRepeatY',
    '$cabinetColorSwatches',
    '$walls',
    '$cornerFillers',
    '$items',
    '$bottomWallItems',
    '$appliances',
    '$cabinets',
    '$ignoredCabinetSpace',
    '$cornerFillerExtraSpace',
    '$cornerCabinetWidth',
    '$minCabinetHeight',
    '$minCabinetDepth',
    '$inchToMm',
    '$toeKickHeight',
    '$minGapForOpenCabinet',
    '$doorThickness',
    '$cabinetSideGap',
    '$backPanelDepth',
    '$smallHandleLength',
    '$largeHandleLength',
    '$violations'
];
const RoomItemExpressions = [
    '$name',
    '$dataKey',
    '$sku',
    '$priceSku',
    '$description',
    '$price',
    '$dealerPrice',
    '$retailPrice',
    '$summary',
    '$room'
];
const RoomItemWithDefaultSummaryExpressions = [
    '$name',
    '$dataKey',
    '$sku',
    '$priceSku',
    '$description',
    '$price',
    '$dealerPrice',
    '$retailPrice',
    '$summary'
];
const WallExpressions = [
    '$active',
    '$name',
    '$direction',
    '$stackMin',
    '$stackMax',
    '$stackFillFrom',
    '$stackFillTo',
    '$startOffset',
    '$endOffset',
    '$height',
    '$minHeight',
    '$x',
    '$wallObjectX',
    '$z',
    '$wallObjectZ',
    '$rotationY',
    '$draggingSurface',
    '$maxWallItemDepth',
    '$maxWallItemHeight',
    '$rearPanelWidths',
    '$continuousCountertopSpaces',
    '$summary',
    '$dimensionIndicatorWallStartX',
    '$dimensionIndicatorWallEndX',
    '$dimensionIndicatorWallLabel',
    '$dimensionIndicatorCabinetsStartX',
    '$dimensionIndicatorCabinetsY',
    '$dimensionIndicatorCabinetsEndX',
    '$dimensionIndicatorRemainingStartX',
    '$dimensionIndicatorRemainingEndX',
    '$dimensionIndicatorRemainingExtrusionZ',
    '$dimensionIndicatorRemainingFilter',
    '$dimensionIndicatorLabelFontSize',
    '$dimensionIndicatorCabinetHeightX',
    '$dimensionIndicatorCabinetHeightY',
    '$dimensionIndicatorCabinetHeightExtrusionX',
    '$dimensionIndicatorCabinetHeightFilter',
    '$minLength',
    '$y',
    '$room',
    '$cabinets',
    '$parts',
    '$wallAppliances',
    '$bottomItems',
    '$topItems',
    '$countertopItems',
    '$fullHeight',
    '$hiddenHeight',
    '$countertopThickness',
    '$wallThickness',
    '$violations'
];
const CornerFillerExpressions = [
    '$netWidth',
    '$offsetX',
    '$offsetZ',
    '$width',
    '$cornerFillerActive',
    '$modelSizeOffset',
    '$wallCornerOffsetX',
    '$wallCornerOffsetZ',
    '$wallCornerHeight',
    '$cornerCabinetExtraWidth',
    '$cornerFillerFilter',
    '$cornerFillerCountertopFilter',
    '$backPanelPartOneFilter',
    '$backPanelPartTwoFilter',
    '$offsetY',
    '$rotation',
    '$countertopPartOneOffsetX',
    '$countertopPartOneOffsetZ',
    '$countertopPartOneWidth',
    '$countertopScaleZero',
    '$countertopScaleOne',
    '$countertopPartOneDepth',
    '$countertopDepthScaleZero',
    '$countertopDepthScaleOne',
    '$countertopPartTwoOffsetX',
    '$countertopPartTwoOffsetZ',
    '$countertopPartTwoWidth',
    '$countertopPartTwoDepth',
    '$backPanelPartOneOffsetX',
    '$backPanelPartOneOffsetZ',
    '$backPanelPartOneRotationY',
    '$backPanelPartOneWidth',
    '$backPanelWidthScaleZero',
    '$backPanelWidthScaleOne',
    '$backPanelPartTwoOffsetX',
    '$backPanelPartTwoOffsetZ',
    '$backPanelPartTwoRotationY',
    '$backPanelPartTwoWidth',
    '$toeKickPartOneOffsetX',
    '$toeKickPartOneOffsetZ',
    '$toeKickPartOneRotationY',
    '$toeKickPartOneWidth',
    '$toeKickWidthScaleZero',
    '$toeKickWidthScaleOne',
    '$toeKickPartOneDepth',
    '$toeKickDepthScaleZero',
    '$toeKickDepthScaleOne',
    '$toeKickPartTwoOffsetX',
    '$toeKickPartTwoOffsetZ',
    '$toeKickPartTwoRotationY',
    '$toeKickPartTwoWidth',
    '$toeKickPartTwoDepth',
    '$room',
    '$name',
    '$sku',
    '$description',
    '$countertopOffsetZ',
    '$heightScaleZero',
    '$heightScaleOne',
    '$wallCornerThickness',
    '$toeKickInset',
    '$frontPanelBottomOverhang'
];
const EndPanelExpressions = [
    '$netDepth',
    '$depth',
    '$endPanelOffsetZ',
    '$name',
    '$sku',
    '$description',
    '$endPanelOffsetY',
    '$endPanelDepth',
    '$endPanelDepthScaleZero',
    '$endPanelDepthScaleOne',
    '$endPanelHeight',
    '$endPanelHeightScaleZero',
    '$endPanelHeightScaleOne',
    '$height',
    '$netWidth'
];
const BottomWallItemWithBackPanelExpressions = [
    '$backPanelFilter',
    '$backPanelOffsetZ',
    '$backPanelWidth',
    '$backPanelWidthScaleZero',
    '$backPanelWidthScaleOne',
    '$backPanelOverhang'
];
const BottomWallItemWithDefaultToeKickExpressions = [
    '$toeKickObjectName',
    '$toeKickOffsetX',
    '$toeKickOffsetZ',
    '$toeKickWidth',
    '$toeKickWidthScaleZero',
    '$toeKickWidthScaleOne',
    '$toeKickDepth',
    '$toeKickDepthScaleZero',
    '$toeKickDepthScaleOne'
];
const BottomCabinetWithApplianceExpressions = [
    '$applianceName',
    '$applianceSku',
    '$applianceDescription',
    '$thumbnailUrl',
    '$appliance',
    '$countertopDepthInnerScaleZero',
    '$countertopDepthInnerScaleOne',
    '$countertopSideWidthScaleZero',
    '$countertopSideWidthScaleOne'
];
const BottomCabinetWithoutApplianceExpressions = [
    '$name',
    '$sku',
    '$description',
    '$thumbnailUrl'
];
const BottomCabinetApplianceExpressions = [
    '$applianceOffsetX',
    '$applianceOffsetY',
    '$applianceOffsetZ',
    '$cabinet'
];
const BottomWallItemWithDefaultCountertopExpressions = [
    '$countertopOffsetX',
    '$countertopWidth',
    '$countertopWidthScaleZero',
    '$countertopWidthScaleOne',
    '$countertopDepth',
    '$countertopDepthScaleZero',
    '$countertopDepthScaleOne'
];
const BottomWallItemWithCustomCountertopExpressions = [
    '$countertopObjectName',
    '$countertopFilter',
    '$countertopOffsetX',
    '$countertopWidth',
    '$countertopWidthScaleZero',
    '$countertopWidthScaleOne',
    '$countertopDepth',
    '$countertopDepthScaleZero',
    '$countertopDepthScaleOne',
    '$countertopDepthInner',
    '$countertopDepthInnerScaleZero',
    '$countertopDepthInnerScaleOne',
    '$countertopSideInnerWidth',
    '$countertopSideWidthScaleZero',
    '$countertopSideWidthScaleOne',
    '$countertopLeftSideOuterWidth',
    '$countertopRightSideOuterWidth'
];
const BurnerBaseW24Expressions = [
    '$bodyObjectName',
    '$netWidth',
    '$countertopDepthInner'
];
const Drawer33Door66Expressions = [
    '$width',
    '$drawerOffsetX',
    '$drawerOffsetY',
    '$doorModelWidthScaleZero',
    '$doorModelWidthScaleOne',
    '$drawerHeight',
    '$doorModelHeightScaleZero',
    '$doorModelHeightScaleOne',
    '$drawerHandleOffsetX',
    '$drawerHandleOffsetY',
    '$handleOffsetZ',
    '$handleLength',
    '$handleModelScaleZero',
    '$handleModelScaleOne',
    '$depth'
];
const FillerExpressions = [
    '$name',
    '$sku',
    '$description',
    '$offsetY',
    '$fillerHeight',
    '$width',
    '$height',
    '$depth'
];
const GrillBaseExpressions = [
    '$grillBodyObjectName',
    '$width',
    '$warmingDrawerPanelColor',
    '$warmingDrawerPanelMetalness',
    '$warmingDrawerPanelRoughness',
    '$warmingDrawerPanelRoughnessMapUrl',
    '$warmingDrawerPanelNormalMapUrl',
    '$warmingDrawer',
    '$depth',
    '$countertopDepthInner'
];
const LynxSedonaGrillExpressions = [
    '$grillObjectName'
];
const LynxSinkExpressions = [
    '$applianceOffsetX',
    '$applianceOffsetY',
    '$width'
];
const ThreeDrawerBaseExpressions = [
    '$width',
    '$drawerOffsetX',
    '$drawerOneOffsetY',
    '$doorModelWidthScaleZero',
    '$doorModelWidthScaleOne',
    '$drawerHeight',
    '$doorModelHeightScaleZero',
    '$doorModelHeightScaleOne',
    '$drawerHandleOffsetX',
    '$drawerOneHandleOffsetY',
    '$handleOffsetZ',
    '$handleLength',
    '$handleModelScaleZero',
    '$handleModelScaleOne',
    '$drawerTwoOffsetY',
    '$drawerTwoHandleOffsetY',
    '$drawerThreeOffsetY',
    '$drawerThreeHandleOffsetY',
    '$depth'
];
const TrashPulloutBaseExpressions = [
    '$width',
    '$depth'
];
const LynxSedonaHoodExpressions = [
    '$offsetX',
    '$depth',
    '$height'
];
const BottomAdjustableDoorApplianceExpressions = [
    '$handingOptions',
    '$offsetX',
    '$offsetY'
];
const LynxProfessionalOutdoorBeverageDispenserW24Expressions = [
    '$towerKitOptions',
    '$towerKit',
    '$netWidth',
    '$depth'
];
const LynxProfessionalSingleTapTowerKitExpressions = [
    '$offsetY'
];
const LynxProfessionalDoubleTapTowerKitExpressions = [
    '$offsetY'
];
const ApplianceWithPowderCoatingExpressions = [
    '$controlPanelColor',
    '$controlPanelMetalness',
    '$controlPanelRoughness',
    '$controlPanelRoughnessMapUrl',
    '$controlPanelNormalMapUrl'
];
const LynxProfessionalTapTowerKitExpressions = [
    '$dispenser'
];
const LynxProfessionalOutdoorIceMachineW15Expressions = [
    '$drainPump',
    '$netWidth',
    '$depth'
];
const LynxWarmingDrawerExpressions = [
    '$cabinet'
];
const BurnerBaseW18Expressions = [
    '$netWidth',
    '$countertopDepthInner'
];
const EvoBaseW36Expressions = [
    '$netWidth',
    '$depth',
    '$countertopDepthInner'
];
const LynxSedonaHoodW36Expressions = [
    '$netWidth'
];
const LynxSedonaHoodW42Expressions = [
    '$netWidth'
];
const LynxSedonaHoodW48Expressions = [
    '$netWidth'
];
const LynxProfessionalRefrigeratorFreezerComboW24Expressions = [
    '$netWidth',
    '$depth'
];
const LynxProfessionalOutdoorRefrigeratorW24Expressions = [
    '$netWidth',
    '$depth'
];
const LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24Expressions = [
    '$netWidth',
    '$depth'
];
const LynxProfessionalRefrigeratorW15Expressions = [
    '$netWidth',
    '$depth'
];
const LynxProfessionalWineCellarW15Expressions = [
    '$netWidth',
    '$depth'
];
const LynxProfessionalTwoDrawerRefrigeratorW24Expressions = [
    '$netWidth',
    '$depth'
];
const LynxNapoliPizzaOvenExpressions = [
    '$netWidth',
    '$depth',
    '$violations'
];
export const $BurnerBaseW18 = new $DomainEntityReflection('BurnerBaseW18', [
    ...BurnerBaseW18Expressions,
    ...BurnerBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $BurnerBaseW24 = new $DomainEntityReflection('BurnerBaseW24', [
    ...BurnerBaseW24Expressions,
    ...BurnerBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $CornerFiller = new $DomainEntityReflection('CornerFiller', [
    ...CornerFillerExpressions
]);
export const $Drawer33Door66 = new $DomainEntityReflection('Drawer33Door66', [
    ...Drawer33Door66Expressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithoutApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $EvoBaseW36 = new $DomainEntityReflection('EvoBaseW36', [
    ...EvoBaseW36Expressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $EvoAffinity25G = new $DomainEntityReflection('EvoAffinity25G', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $EvoAffinity30G = new $DomainEntityReflection('EvoAffinity30G', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $EndPanel = new $DomainEntityReflection('EndPanel', [
    ...EndPanelExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $Filler = new $DomainEntityReflection('Filler', [
    ...FillerExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $FullDoorBase = new $DomainEntityReflection('FullDoorBase', [
    ...FullDoorBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $GrillBase = new $DomainEntityReflection('GrillBase', [
    ...GrillBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $KamadoGrillBase = new $DomainEntityReflection('KamadoGrillBase', [
    ...KamadoGrillBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $LynxAsadoGriddgle = new $DomainEntityReflection('LynxAsadoGriddgle', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxKamadoGrill = new $DomainEntityReflection('LynxKamadoGrill', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $LynxNapoliPizzaOven = new $DomainEntityReflection('LynxNapoliPizzaOven', [
    ...LynxNapoliPizzaOvenExpressions,
    ...CountertopWallItemExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalCocktailStation = new $DomainEntityReflection('LynxProfessionalCocktailStation', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalGrillW30 = new $DomainEntityReflection('LynxProfessionalGrillW30', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalGrillW36 = new $DomainEntityReflection('LynxProfessionalGrillW36', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalGrillW42 = new $DomainEntityReflection('LynxProfessionalGrillW42', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalGrillW54 = new $DomainEntityReflection('LynxProfessionalGrillW54', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalSingleBurner = new $DomainEntityReflection('LynxProfessionalSingleBurner', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalDoubleBurner = new $DomainEntityReflection('LynxProfessionalDoubleBurner', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalPowerBurner = new $DomainEntityReflection('LynxProfessionalPowerBurner', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalOutdoorBeverageDispenserW24 = new $DomainEntityReflection('LynxProfessionalOutdoorBeverageDispenserW24', [
    ...LynxProfessionalOutdoorBeverageDispenserW24Expressions,
    ...BottomAdjustableDoorApplianceExpressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalRefrigeratorFreezerComboW24 = new $DomainEntityReflection('LynxProfessionalRefrigeratorFreezerComboW24', [
    ...LynxProfessionalRefrigeratorFreezerComboW24Expressions,
    ...BottomAdjustableDoorApplianceExpressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalOutdoorRefrigeratorW24 = new $DomainEntityReflection('LynxProfessionalOutdoorRefrigeratorW24', [
    ...LynxProfessionalOutdoorRefrigeratorW24Expressions,
    ...BottomAdjustableDoorApplianceExpressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24 = new $DomainEntityReflection('LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24', [
    ...LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24Expressions,
    ...BottomAdjustableDoorApplianceExpressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalRefrigeratorW15 = new $DomainEntityReflection('LynxProfessionalRefrigeratorW15', [
    ...LynxProfessionalRefrigeratorW15Expressions,
    ...BottomAdjustableDoorApplianceExpressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalWineCellarW15 = new $DomainEntityReflection('LynxProfessionalWineCellarW15', [
    ...LynxProfessionalWineCellarW15Expressions,
    ...BottomAdjustableDoorApplianceExpressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalTwoDrawerRefrigeratorW24 = new $DomainEntityReflection('LynxProfessionalTwoDrawerRefrigeratorW24', [
    ...LynxProfessionalTwoDrawerRefrigeratorW24Expressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalOutdoorIceMachineW15 = new $DomainEntityReflection('LynxProfessionalOutdoorIceMachineW15', [
    ...LynxProfessionalOutdoorIceMachineW15Expressions,
    ...BottomAdjustableDoorApplianceExpressions,
    ...BottomWallApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalOutdoorIceMachineDrainPump = new $DomainEntityReflection('LynxProfessionalOutdoorIceMachineDrainPump', [
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalSingleTapTowerKit = new $DomainEntityReflection('LynxProfessionalSingleTapTowerKit', [
    ...LynxProfessionalSingleTapTowerKitExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...LynxProfessionalTapTowerKitExpressions,
    ...ApplianceExpressions
]);
export const $LynxProfessionalDoubleTapTowerKit = new $DomainEntityReflection('LynxProfessionalDoubleTapTowerKit', [
    ...LynxProfessionalDoubleTapTowerKitExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...LynxProfessionalTapTowerKitExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaGrillW30 = new $DomainEntityReflection('LynxSedonaGrillW30', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...LynxSedonaGrillExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaGrillW36 = new $DomainEntityReflection('LynxSedonaGrillW36', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...LynxSedonaGrillExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaGrillW42 = new $DomainEntityReflection('LynxSedonaGrillW42', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...LynxSedonaGrillExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaSingleBurner = new $DomainEntityReflection('LynxSedonaSingleBurner', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaDoubleBurner = new $DomainEntityReflection('LynxSedonaDoubleBurner', [
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaHoodW36 = new $DomainEntityReflection('LynxSedonaHoodW36', [
    ...LynxSedonaHoodW36Expressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...TopWallItemExpressions,
    ...WallItemExpressions,
    ...LynxSedonaHoodExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaHoodW42 = new $DomainEntityReflection('LynxSedonaHoodW42', [
    ...LynxSedonaHoodW42Expressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...TopWallItemExpressions,
    ...WallItemExpressions,
    ...LynxSedonaHoodExpressions,
    ...ApplianceExpressions
]);
export const $LynxSedonaHoodW48 = new $DomainEntityReflection('LynxSedonaHoodW48', [
    ...LynxSedonaHoodW48Expressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...TopWallItemExpressions,
    ...WallItemExpressions,
    ...LynxSedonaHoodExpressions,
    ...ApplianceExpressions
]);
export const $LynxSinkW18 = new $DomainEntityReflection('LynxSinkW18', [
    ...LynxSinkExpressions,
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $LynxSinkW24 = new $DomainEntityReflection('LynxSinkW24', [
    ...LynxSinkExpressions,
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $LynxSinkW30 = new $DomainEntityReflection('LynxSinkW30', [
    ...LynxSinkExpressions,
    ...BottomCabinetApplianceExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceExpressions
]);
export const $LynxSinkBase = new $DomainEntityReflection('LynxSinkBase', [
    ...LynxSinkBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $LynxWarmingDrawer = new $DomainEntityReflection('LynxWarmingDrawer', [
    ...LynxWarmingDrawerExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...ApplianceWithPowderCoatingExpressions,
    ...ApplianceExpressions
]);
export const $Room = new $DomainEntityReflection('Room', [
    ...RoomExpressions
]);
export const $RearPanel = new $DomainEntityReflection('RearPanel', [
    ...RearPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions
]);
export const $SinkBase = new $DomainEntityReflection('SinkBase', [
    ...SinkBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithApplianceExpressions,
    ...BottomWallItemWithCustomCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $ThreeDrawerBase = new $DomainEntityReflection('ThreeDrawerBase', [
    ...ThreeDrawerBaseExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithoutApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $TrashPulloutBase = new $DomainEntityReflection('TrashPulloutBase', [
    ...TrashPulloutBaseExpressions,
    ...AdjustableDoorCabinetExpressions,
    ...BottomCabinetExpressions,
    ...BottomCabinetWithoutApplianceExpressions,
    ...BottomWallItemWithDefaultCountertopExpressions,
    ...BottomWallItemWithDefaultToeKickExpressions,
    ...BottomWallItemWithBackPanelExpressions,
    ...RoomItemExpressions,
    ...RoomItemWithDefaultSummaryExpressions,
    ...BottomWallItemExpressions,
    ...WallItemExpressions
]);
export const $Wall = new $DomainEntityReflection('Wall', [
    ...WallExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    BurnerBaseW18.type,
    BurnerBaseW24.type,
    CornerFiller.type,
    Drawer33Door66.type,
    EvoBaseW36.type,
    EvoAffinity25G.type,
    EvoAffinity30G.type,
    EndPanel.type,
    Filler.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxAsadoGriddgle.type,
    LynxKamadoGrill.type,
    LynxNapoliPizzaOven.type,
    LynxProfessionalCocktailStation.type,
    LynxProfessionalGrillW30.type,
    LynxProfessionalGrillW36.type,
    LynxProfessionalGrillW42.type,
    LynxProfessionalGrillW54.type,
    LynxProfessionalSingleBurner.type,
    LynxProfessionalDoubleBurner.type,
    LynxProfessionalPowerBurner.type,
    LynxProfessionalOutdoorBeverageDispenserW24.type,
    LynxProfessionalRefrigeratorFreezerComboW24.type,
    LynxProfessionalOutdoorRefrigeratorW24.type,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24.type,
    LynxProfessionalRefrigeratorW15.type,
    LynxProfessionalWineCellarW15.type,
    LynxProfessionalTwoDrawerRefrigeratorW24.type,
    LynxProfessionalOutdoorIceMachineW15.type,
    LynxProfessionalOutdoorIceMachineDrainPump.type,
    LynxProfessionalSingleTapTowerKit.type,
    LynxProfessionalDoubleTapTowerKit.type,
    LynxSedonaGrillW30.type,
    LynxSedonaGrillW36.type,
    LynxSedonaGrillW42.type,
    LynxSedonaSingleBurner.type,
    LynxSedonaDoubleBurner.type,
    LynxSedonaHoodW36.type,
    LynxSedonaHoodW42.type,
    LynxSedonaHoodW48.type,
    LynxSinkW18.type,
    LynxSinkW24.type,
    LynxSinkW30.type,
    LynxSinkBase.type,
    LynxWarmingDrawer.type,
    Room.type,
    RearPanel.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type,
    Wall.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Room.type
]);
export const $StaticEntity = new EnhancedAliasReflection('$StaticEntity', [
    Room.type,
    Wall.type,
    CornerFiller.type
]);
export const $BurnerBase = new EnhancedAliasReflection('$BurnerBase', [
    BurnerBaseW18.type,
    BurnerBaseW24.type
]);
export const $AdjustableDoorCabinet = new EnhancedAliasReflection('$AdjustableDoorCabinet', [
    ...BurnerBase.types,
    Drawer33Door66.type,
    EvoBaseW36.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    SinkBase.type,
    TrashPulloutBase.type
]);
export const $TopAppliance = new EnhancedAliasReflection('$TopAppliance', [
    LynxSedonaHoodW36.type,
    LynxSedonaHoodW42.type,
    LynxSedonaHoodW48.type
]);
export const $LynxSink = new EnhancedAliasReflection('$LynxSink', [
    LynxSinkW18.type,
    LynxSinkW24.type,
    LynxSinkW30.type
]);
export const $BottomAdjustableDoorAppliance = new EnhancedAliasReflection('$BottomAdjustableDoorAppliance', [
    LynxProfessionalOutdoorBeverageDispenserW24.type,
    LynxProfessionalRefrigeratorFreezerComboW24.type,
    LynxProfessionalOutdoorRefrigeratorW24.type,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24.type,
    LynxProfessionalRefrigeratorW15.type,
    LynxProfessionalWineCellarW15.type,
    LynxProfessionalOutdoorIceMachineW15.type
]);
export const $BottomNonAdjustableDoorAppliance = new EnhancedAliasReflection('$BottomNonAdjustableDoorAppliance', [
    LynxProfessionalTwoDrawerRefrigeratorW24.type,
    LynxProfessionalSingleTapTowerKit.type,
    LynxProfessionalDoubleTapTowerKit.type,
    LynxProfessionalOutdoorIceMachineDrainPump.type,
    LynxWarmingDrawer.type
]);
export const $BottomCabinetAppliance = new EnhancedAliasReflection('$BottomCabinetAppliance', [
    LynxAsadoGriddgle.type,
    LynxKamadoGrill.type,
    LynxProfessionalGrillW30.type,
    LynxProfessionalGrillW36.type,
    LynxProfessionalGrillW42.type,
    LynxProfessionalGrillW54.type,
    LynxSedonaGrillW30.type,
    LynxSedonaGrillW36.type,
    LynxSedonaGrillW42.type,
    LynxProfessionalCocktailStation.type,
    LynxProfessionalSingleBurner.type,
    LynxProfessionalDoubleBurner.type,
    LynxProfessionalPowerBurner.type,
    LynxSedonaSingleBurner.type,
    LynxSedonaDoubleBurner.type,
    LynxSinkW18.type,
    LynxSinkW24.type,
    LynxSinkW30.type,
    EvoAffinity25G.type,
    EvoAffinity30G.type
]);
export const $CountertopAppliance = new EnhancedAliasReflection('$CountertopAppliance', [
    LynxNapoliPizzaOven.type
]);
export const $CountertopWallItem = new EnhancedAliasReflection('$CountertopWallItem', [
    ...CountertopAppliance.types
]);
export const $BottomWallAppliance = new EnhancedAliasReflection('$BottomWallAppliance', [
    LynxProfessionalOutdoorBeverageDispenserW24.type,
    LynxProfessionalRefrigeratorFreezerComboW24.type,
    LynxProfessionalOutdoorRefrigeratorW24.type,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24.type,
    LynxProfessionalRefrigeratorW15.type,
    LynxProfessionalWineCellarW15.type,
    LynxProfessionalTwoDrawerRefrigeratorW24.type,
    LynxProfessionalOutdoorIceMachineW15.type
]);
export const $BottomAppliance = new EnhancedAliasReflection('$BottomAppliance', [
    ...BottomCabinetAppliance.types,
    ...BottomWallAppliance.types,
    LynxProfessionalSingleTapTowerKit.type,
    LynxProfessionalDoubleTapTowerKit.type,
    LynxProfessionalOutdoorIceMachineDrainPump.type,
    LynxWarmingDrawer.type
]);
export const $SwatchPowderCoatableRoomItem = new EnhancedAliasReflection('$SwatchPowderCoatableRoomItem', [
    ...BurnerBase.types,
    CornerFiller.type,
    Drawer33Door66.type,
    EvoBaseW36.type,
    EndPanel.type,
    Filler.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    RearPanel.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $PulsePowderCoatableRoomItem = new EnhancedAliasReflection('$PulsePowderCoatableRoomItem', [
    ...BurnerBase.types,
    Drawer33Door66.type,
    EvoBaseW36.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $BottomCabinet = new EnhancedAliasReflection('$BottomCabinet', [
    ...BurnerBase.types,
    Drawer33Door66.type,
    EvoBaseW36.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $BottomCabinetWithAppliance = new EnhancedAliasReflection('$BottomCabinetWithAppliance', [
    ...BurnerBase.types,
    EvoBaseW36.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    SinkBase.type
]);
export const $BottomCabinetWithoutAppliance = new EnhancedAliasReflection('$BottomCabinetWithoutAppliance', [
    Drawer33Door66.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $BottomCabinetWithDefaultDetail = new EnhancedAliasReflection('$BottomCabinetWithDefaultDetail', [
    BurnerBaseW18.type,
    Drawer33Door66.type,
    EvoBaseW36.type,
    FullDoorBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $BottomPart = new EnhancedAliasReflection('$BottomPart', [
    EndPanel.type,
    Filler.type,
    RearPanel.type
]);
export const $BottomWallItemWithDefaultCountertop = new EnhancedAliasReflection('$BottomWallItemWithDefaultCountertop', [
    Drawer33Door66.type,
    EndPanel.type,
    Filler.type,
    LynxProfessionalOutdoorBeverageDispenserW24.type,
    LynxProfessionalRefrigeratorFreezerComboW24.type,
    LynxProfessionalOutdoorRefrigeratorW24.type,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24.type,
    LynxProfessionalRefrigeratorW15.type,
    LynxProfessionalWineCellarW15.type,
    LynxProfessionalTwoDrawerRefrigeratorW24.type,
    LynxProfessionalOutdoorIceMachineW15.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $BottomWallItemWithCustomCountertop = new EnhancedAliasReflection('$BottomWallItemWithCustomCountertop', [
    ...BurnerBase.types,
    EvoBaseW36.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    SinkBase.type
]);
export const $BottomWallItemWithDefaultToeKick = new EnhancedAliasReflection('$BottomWallItemWithDefaultToeKick', [
    ...BurnerBase.types,
    Drawer33Door66.type,
    EvoBaseW36.type,
    Filler.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxSinkBase.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $BottomWallItemWithBackPanel = new EnhancedAliasReflection('$BottomWallItemWithBackPanel', [
    ...BottomCabinet.types,
    ...BottomWallAppliance.types,
    Filler.type
]);
export const $RoomItem = new EnhancedAliasReflection('$RoomItem', [
    ...BottomAppliance.types,
    ...BottomCabinet.types,
    ...BottomPart.types,
    ...TopAppliance.types,
    ...CountertopWallItem.types
]);
export const $RoomItemWithDefaultPrice = new EnhancedAliasReflection('$RoomItemWithDefaultPrice', [
    ...BurnerBase.types,
    Drawer33Door66.type,
    EvoBaseW36.type,
    EvoAffinity25G.type,
    EvoAffinity30G.type,
    EndPanel.type,
    Filler.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxKamadoGrill.type,
    LynxNapoliPizzaOven.type,
    LynxProfessionalCocktailStation.type,
    LynxProfessionalRefrigeratorFreezerComboW24.type,
    LynxProfessionalOutdoorRefrigeratorW24.type,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24.type,
    LynxProfessionalRefrigeratorW15.type,
    LynxProfessionalWineCellarW15.type,
    LynxProfessionalOutdoorIceMachineW15.type,
    LynxProfessionalOutdoorBeverageDispenserW24.type,
    LynxProfessionalTwoDrawerRefrigeratorW24.type,
    LynxProfessionalOutdoorIceMachineDrainPump.type,
    LynxProfessionalSingleTapTowerKit.type,
    LynxProfessionalDoubleTapTowerKit.type,
    LynxSedonaHoodW36.type,
    LynxSedonaHoodW42.type,
    LynxSedonaHoodW48.type,
    LynxSinkW18.type,
    LynxSinkW24.type,
    LynxSinkW30.type,
    LynxSinkBase.type,
    RearPanel.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type,
    LynxSedonaGrillW30.type,
    LynxSedonaGrillW36.type,
    LynxSedonaGrillW42.type
]);
export const $RoomItemWithDefaultSummary = new EnhancedAliasReflection('$RoomItemWithDefaultSummary', [
    ...BurnerBase.types,
    Drawer33Door66.type,
    EvoBaseW36.type,
    EvoAffinity25G.type,
    EvoAffinity30G.type,
    EndPanel.type,
    Filler.type,
    FullDoorBase.type,
    GrillBase.type,
    KamadoGrillBase.type,
    LynxAsadoGriddgle.type,
    LynxKamadoGrill.type,
    LynxNapoliPizzaOven.type,
    LynxProfessionalCocktailStation.type,
    LynxProfessionalGrillW30.type,
    LynxProfessionalGrillW36.type,
    LynxProfessionalGrillW42.type,
    LynxProfessionalGrillW54.type,
    LynxProfessionalSingleBurner.type,
    LynxProfessionalDoubleBurner.type,
    LynxProfessionalPowerBurner.type,
    LynxProfessionalRefrigeratorFreezerComboW24.type,
    LynxProfessionalOutdoorRefrigeratorW24.type,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24.type,
    LynxProfessionalRefrigeratorW15.type,
    LynxProfessionalWineCellarW15.type,
    LynxProfessionalTwoDrawerRefrigeratorW24.type,
    LynxProfessionalOutdoorIceMachineDrainPump.type,
    LynxProfessionalSingleTapTowerKit.type,
    LynxProfessionalDoubleTapTowerKit.type,
    LynxSedonaGrillW30.type,
    LynxSedonaGrillW36.type,
    LynxSedonaGrillW42.type,
    LynxSedonaSingleBurner.type,
    LynxSedonaDoubleBurner.type,
    LynxSedonaHoodW36.type,
    LynxSedonaHoodW42.type,
    LynxSedonaHoodW48.type,
    LynxWarmingDrawer.type,
    LynxSinkW18.type,
    LynxSinkW24.type,
    LynxSinkW30.type,
    LynxSinkBase.type,
    RearPanel.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $BottomWallItem = new EnhancedAliasReflection('$BottomWallItem', [
    ...BottomCabinet.types,
    ...BottomWallAppliance.types,
    Filler.type,
    EndPanel.type
]);
export const $TopWallItem = new EnhancedAliasReflection('$TopWallItem', [
    ...TopAppliance.types
]);
export const $WallItem = new EnhancedAliasReflection('$WallItem', [
    ...BottomWallItem.types,
    ...TopWallItem.types,
    ...CountertopWallItem.types
]);
export const $LynxProfessionalGrill = new EnhancedAliasReflection('$LynxProfessionalGrill', [
    LynxProfessionalGrillW30.type,
    LynxProfessionalGrillW36.type,
    LynxProfessionalGrillW42.type,
    LynxProfessionalGrillW54.type
]);
export const $LynxSedonaGrill = new EnhancedAliasReflection('$LynxSedonaGrill', [
    LynxSedonaGrillW30.type,
    LynxSedonaGrillW36.type,
    LynxSedonaGrillW42.type
]);
export const $LynxGrill = new EnhancedAliasReflection('$LynxGrill', [
    ...LynxProfessionalGrill.types,
    ...LynxSedonaGrill.types
]);
export const $LynxProfessionalBurner = new EnhancedAliasReflection('$LynxProfessionalBurner', [
    LynxProfessionalSingleBurner.type,
    LynxProfessionalDoubleBurner.type,
    LynxProfessionalPowerBurner.type
]);
export const $LynxSedonaBurner = new EnhancedAliasReflection('$LynxSedonaBurner', [
    LynxSedonaSingleBurner.type,
    LynxSedonaDoubleBurner.type
]);
export const $LynxBurner = new EnhancedAliasReflection('$LynxBurner', [
    ...LynxProfessionalBurner.types,
    ...LynxSedonaBurner.types
]);
export const $LynxProfessionalTapTowerKit = new EnhancedAliasReflection('$LynxProfessionalTapTowerKit', [
    LynxProfessionalSingleTapTowerKit.type,
    LynxProfessionalDoubleTapTowerKit.type
]);
export const $ApplianceWithPowderCoating = new EnhancedAliasReflection('$ApplianceWithPowderCoating', [
    ...LynxProfessionalGrill.types,
    LynxAsadoGriddgle.type,
    ...LynxBurner.types,
    LynxWarmingDrawer.type
]);
export const $ResizableWallItem = new EnhancedAliasReflection('$ResizableWallItem', [
    Drawer33Door66.type,
    Filler.type,
    FullDoorBase.type,
    GrillBase.type,
    LynxSinkBase.type,
    SinkBase.type,
    ThreeDrawerBase.type,
    TrashPulloutBase.type
]);
export const $LynxSedonaHood = new EnhancedAliasReflection('$LynxSedonaHood', [
    LynxSedonaHoodW36.type,
    LynxSedonaHoodW42.type,
    LynxSedonaHoodW48.type
]);
export const $Hood = new EnhancedAliasReflection('$Hood', [
    ...LynxSedonaHood.types
]);
export const $Appliance = new EnhancedAliasReflection('$Appliance', [
    ...TopAppliance.types,
    ...BottomAppliance.types,
    ...CountertopAppliance.types
]);
export const $entityReflections = {
    BurnerBaseW18: $BurnerBaseW18,
    BurnerBaseW24: $BurnerBaseW24,
    CornerFiller: $CornerFiller,
    Drawer33Door66: $Drawer33Door66,
    EvoBaseW36: $EvoBaseW36,
    EvoAffinity25G: $EvoAffinity25G,
    EvoAffinity30G: $EvoAffinity30G,
    EndPanel: $EndPanel,
    Filler: $Filler,
    FullDoorBase: $FullDoorBase,
    GrillBase: $GrillBase,
    KamadoGrillBase: $KamadoGrillBase,
    LynxAsadoGriddgle: $LynxAsadoGriddgle,
    LynxKamadoGrill: $LynxKamadoGrill,
    LynxNapoliPizzaOven: $LynxNapoliPizzaOven,
    LynxProfessionalCocktailStation: $LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30: $LynxProfessionalGrillW30,
    LynxProfessionalGrillW36: $LynxProfessionalGrillW36,
    LynxProfessionalGrillW42: $LynxProfessionalGrillW42,
    LynxProfessionalGrillW54: $LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner: $LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner: $LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner: $LynxProfessionalPowerBurner,
    LynxProfessionalOutdoorBeverageDispenserW24: $LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24: $LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24: $LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24: $LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15: $LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15: $LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24: $LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15: $LynxProfessionalOutdoorIceMachineW15,
    LynxProfessionalOutdoorIceMachineDrainPump: $LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit: $LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit: $LynxProfessionalDoubleTapTowerKit,
    LynxSedonaGrillW30: $LynxSedonaGrillW30,
    LynxSedonaGrillW36: $LynxSedonaGrillW36,
    LynxSedonaGrillW42: $LynxSedonaGrillW42,
    LynxSedonaSingleBurner: $LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner: $LynxSedonaDoubleBurner,
    LynxSedonaHoodW36: $LynxSedonaHoodW36,
    LynxSedonaHoodW42: $LynxSedonaHoodW42,
    LynxSedonaHoodW48: $LynxSedonaHoodW48,
    LynxSinkW18: $LynxSinkW18,
    LynxSinkW24: $LynxSinkW24,
    LynxSinkW30: $LynxSinkW30,
    LynxSinkBase: $LynxSinkBase,
    LynxWarmingDrawer: $LynxWarmingDrawer,
    Room: $Room,
    RearPanel: $RearPanel,
    SinkBase: $SinkBase,
    ThreeDrawerBase: $ThreeDrawerBase,
    TrashPulloutBase: $TrashPulloutBase,
    Wall: $Wall
};

//# sourceMappingURL=enhanced-model.js.map